import { Clear } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Keys from "../../constants/Keys";

interface Props {
  open: boolean;
  title?: string;
  onClose(): void;
  imageBase64?: string;
  imageUrl?: string;
}

export default function PreviewDialog({
  open,
  title,
  onClose,
  imageBase64,
  imageUrl,
}: Props) {
  return (
    <Dialog open={open} maxWidth={false}>
      <DialogTitle style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography>{title}</Typography>
        <Box display="flex" sx={{ cursor: "pointer" }} onClick={onClose}>
          <Clear />
        </Box>
      </DialogTitle>
      <DialogContent
        style={{ padding: "1rem", paddingBottom: 0, paddingTop: 0 }}
      >
        <iframe
          height={window.innerHeight * 0.7}
          width={window.innerWidth * 0.6}
          src={
            imageBase64 ??
            `${Keys.Public_CDN}Sharepoint/previewImage?uri=https://publiccdn.sharepointonline.com/${Keys.SharePoint_BaseUrl}${imageUrl}`
          }
        />
      </DialogContent>
    </Dialog>
  );
}
